export enum RowHeightLevel {
  Short = 'short',
  Medium = 'medium',
  Tall = 'tall',
  ExtraTall = 'extraTall',
  AutoFit = 'autoFit',
}

export enum ViewType {
  Grid = 'grid',
  Calendar = 'calendar',
  Kanban = 'kanban',
  Form = 'form',
  Gallery = 'gallery',
  Gantt = 'gantt',
}
